import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ExportContainerService } from '../../../Services/DataProcess/export-container.service';
import { LoginService } from '../../../Services/login.service';
import { ExportContainer } from '../../../Model/dataProcess/exportContainer';

@Component({
    selector: 'np-export-container-details',
    templateUrl: './export-container-details.component.html',
    styleUrls: ['./export-container-details.component.css'],
    standalone: false
})
export class ExportContainerDetailsComponent implements OnInit {
    container: ExportContainer;
    containerName = '';
    isLoading = true;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private exportContainerService: ExportContainerService,
        private loginService: LoginService
    ) {}

    async ngOnInit(): Promise<void> {
        const id = this.route.snapshot.paramMap.get('id');
        if (id) {
            await this.loadContainer(id);
        }
    }

    private async loadContainer(id: string): Promise<void> {
        this.isLoading = true;
        try {
            this.container = await this.exportContainerService.get(id, this.loginService.currentCustomer.id);
            this.containerName = this.container?.name ?? '';
        } finally {
            this.isLoading = false;
        }
    }

    goBack(): void {
        this.router.navigate(['/dataprocess/exports']);
    }
}
